import React from "react";

// Array of brands with their logo, alt text, and link
const brands = [
  {
    name: "Bajaj",
    logo: "https://res.cloudinary.com/dpm5nmt2a/image/upload/v1736496719/Bajaj_1_znvlbb.jpg",
    alt: "Bajaj",
    link: "https://www.bajajauto.com",
  },
  {
    name: "Chetak",
    logo: "https://res.cloudinary.com/dpm5nmt2a/image/upload/v1736496719/Chetak_1_e38wei.jpg",
    alt: "Chetak",
    link: "https://www.chetak.com",
  },
  {
    name: "Triumph",
    logo: "https://res.cloudinary.com/dpm5nmt2a/image/upload/v1736496719/Triumph_1_gnsvp1.jpg",
    alt: "Triumph",
    link: "https://www.triumphmotorcycles.in",
  },
  {
    name: "Hyundai",
    logo: "https://res.cloudinary.com/dpm5nmt2a/image/upload/v1736496719/Hyundai_1_vn8aqy.jpg",
    alt: "Hyundai",
    link: "https://shivang.hyundaimotor.in",
  },
  {
    name: "Ford",
    logo: "https://res.cloudinary.com/dpm5nmt2a/image/upload/v1736496719/Ford_ov1tfe.jpg",
    alt: "Ford",
    link: "https://www.india.ford.com",
  },
];

const BrandLogosPage = () => {
  return (
    <div className='text-center py-4'>
      <h2 className='text-xl text-black md:text-3xl font-bold mb-6'>
        Authorized Dealer of Automotive Brands
      </h2>
      {/* Dynamically render brand logos */}
      <div className='grid gap-4 px-4'>
        {/* Mobile Layout */}
        <div className='grid grid-cols-2 gap-4 md:hidden'>
          {brands.map((brand, index) => (
            <a
              key={index}
              href={brand.link}
              target='_blank'
              rel='noopener noreferrer'
              className={`relative overflow-hidden rounded-lg bg-white shadow-xl transform transition-transform duration-300 hover:shadow-xl cursor-pointer${
                index === 0 || index === 2 || index === brands.length - 1
                  ? "p-8"
                  : ""
              } ${index === 3 ? "" : ""}`}
            >
              <img
                src={brand.logo}
                alt={brand.alt}
                className={` w-full h-full transition-transform duration-700 transform hover:scale-105 ${
                  index === 1 ? "object-cover" : "object-cover"
                }`}
              />
            </a>
          ))}
        </div>
        {/* Medium and Larger Screens */}
        <div className='hidden md:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 p-4  md:h-[15vh] lg:h-[20vh] xl:h-[24vh] mx-auto bg-white shadow-2xl rounded-2xl px-8'>
          {brands.map((brand, index) => (
            <a
              key={index}
              href={brand.link}
              target='_blank'
              rel='noopener noreferrer'
              // className={`flex items-center bg-white justify-center border-r hover:shadow-3xl rounded-xl overflow-hidden transition-all duration-700 ease-in-out  ${
              //   index === 0 || index === 2 || index === brands.length - 1
              //     ? "p-5"
              //     : ""
              // } ${index === 3 ? "" : ""}`}
              className={`relative overflow-hidden rounded-lg bg-white shadow-md transform transition-transform duration-700 hover:shadow-2xl cursor-pointer${
                index === 0 || index === 2 || index === brands.length - 1
                  ? ""
                  : ""
              } ${index === 3 ? "" : ""}`}
            >
              <img
                src={brand.logo}
                alt={brand.alt}
                className={` w-full h-full transition-transform duration-700 transform  ${
                  index === 1 ? "object-cover" : "object-cover"
                }`}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandLogosPage;
